module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('multipane', {
    staticClass: "custom-resizer",
    attrs: {
      "layout": "vertical"
    }
  }, [_c('div', {
    staticClass: "pane",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('multipane-resizer'), _vm._v(" "), _c('div', {
    staticClass: "pane",
    style: ({
      flexGrow: 1
    })
  }, [(_vm.params.id) ? [_c('router-view', {
    attrs: {
      "name": "a"
    }
  })] : [_c('div', {
    staticClass: "index-box"
  })]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccf05366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Documents/Documents.vue
// module id = 1460
// module chunks = 0